import React from "react";
import { Partner } from "../../api";
import { PartnerConfig } from "../../partner_config";
import { Spacer } from "../../spacer";
import {
  CapacityPicker,
  CityPicker,
  ListingLocationPicker,
} from "../../template_offering_listing_base";
import { TemplatePartnerPortalIndexV2 } from "./template_partner_portal_index_v2";
import styles from "./portal_meeting_room_page.module.css";
import { PortalMeetingRoomList } from "../components/portal_meeting_room_list";
import { FAKE_MEETING_ROOM_LIST } from "../fake_data";
import { useMediaQuery } from "../../../hooks";
import { PortalBackButton } from "../components/portal_back_button";

interface PortalMeetingRoomPageProps {
  partnerConfig: PartnerConfig;
  partner: Partner;
}

export function PortalMeetingRoomPage({
  partnerConfig,
  partner,
}: PortalMeetingRoomPageProps) {
  const { device } = useMediaQuery();

  return (
    <TemplatePartnerPortalIndexV2
      partner={partner}
      partnerConfig={partnerConfig}
    >
      <div>
        <Spacer size={device === "mobile" ? 38 : 45} />
        <PortalBackButton>Back to Your Membership</PortalBackButton>
        <Spacer size={device === "mobile" ? 38 : 45} />
        <div className={styles.title}>Choose a meeting room</div>
        <Spacer size={device === "mobile" ? 24 : 32} />
        <div className={styles.filtersWrapper}>
          <div className={styles.filterWrapper}>
            <CapacityPicker onChange={() => {}} />
          </div>
          <div className={styles.filterWrapper}>
            <CityPicker cities={[]} onChange={() => {}} />
          </div>
          <div className={styles.filterWrapper}>
            <ListingLocationPicker locations={[]} onChange={() => {}} />
          </div>
        </div>
        <Spacer size={device === "mobile" ? 27 : 32} />
        <div className={styles.location}>New York</div>
        <Spacer size={device === "mobile" ? 24 : 35} />
        <PortalMeetingRoomList
          rooms={FAKE_MEETING_ROOM_LIST}
          partnerId={partner.id}
        />
      </div>
    </TemplatePartnerPortalIndexV2>
  );
}
